import { UnifiedProfilePage } from "@b2b/ui-components/features/ProfileSettings";
import { BizcoverIndiaFigmaHeader } from "../../components/marketing/BizcoverIndiaFigmaHeader";

export default function Profile() {
  return (
    <div className="min-h-screen bg-[#f4f6f8] flex flex-col">
      <BizcoverIndiaFigmaHeader />
      <main className="flex-1">
        <UnifiedProfilePage />
      </main>
    </div>
  );
}
